import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TreatmentIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M31 11.67L26.7902 4.92L20.5983 8.77V1H12.4017V8.77L6.20976 4.92L2 11.67L8.96576 16L2 20.33L6.20976 27.08L12.4017 23.23V31H20.5983V23.23L26.7902 27.08L31 20.33L24.0342 16L31 11.67Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
